import * as React from "react";
import Box from "@mui/material/Box";
import classes from "./FundsTransferModal.module.css";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Controller, useForm } from "react-hook-form";

import { Grid, TextField, styled } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch, useSelector } from "react-redux";

import TextFieldForm from "../../../../components/common/textFieldForm";

import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useLanguage } from "../../../../context/LanguageContext";
import { useNavigate } from "react-router-dom";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "35vw",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: "30px",
};

const ColorButton = styled(Button)(({ theme }) => ({
    color: "#FFFFFF",
    // backgroundColor: "#F84B67",
    backgroundColor: "#323232",
    border: "1px solid #CCC",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "183px",
    height: "50px",
    "&:hover": {
        background: "#808080",
        color: "white",
    },
}));

const ColorButton1 = styled(Button)(({ theme }) => ({
    backgroundColor: "var(--button-color)",
    color: "#ffffff",
    border: "1px solid #CCC",
    borderRadius: "8px",
    width: "130px",
    height: "40px",
    "&:hover": {
        backgroundColor: "var(--button-hover-color)",
    },
    "&.Mui-disabled": {
        backgroundColor: "var(--light-color)",
        color: "var(--button-color)",
        cursor: "not-allowed",
    },
}));

const ColorButton2 = styled(Button)(({ theme }) => ({
    color: "#707070",

    // backgroundColor: "#F84B67",
    // backgroundColor: "#323232",
    background: "#FFF",
    border: "1px solid #707070",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "183px",
    height: "40px",
    "&:hover": {
        background: "var(--button-hover-color)",
        color: "white",
    },
}));

const defaultFormData = {
    accnumber: "",
    ifsccode: "",
    nickname: "",
    fullname: "",
    mobilenum: "",
    tpin: "",
};

export default function FundsTransferModal({
    open,
    handleClose,
    beneType,
    userId,
    handlerefresh,
}) {
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        register,
        watch,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: defaultFormData,
        mode: "onChange",
    });

    const { loading, error, isAuthenticated, user, menu } = useSelector(
        (state) => state.auth
    );
    const isFundTransferEnabled = menu?.[21] == 1;
    const isNeftTabEnabled = isFundTransferEnabled && menu?.[22] == 1;
    const isRTGSTabEnabled = isFundTransferEnabled && menu?.[23] == 1;
    const isWithinBankTabEnabled = isFundTransferEnabled && menu?.[24] == 1;
    const isSelfTransferTabEnabled = isFundTransferEnabled && menu?.[25] == 1;

    const transferEnabled = {
        neft: isNeftTabEnabled,
        rtgs: isRTGSTabEnabled,
        withinbank: isWithinBankTabEnabled,
        selfaccount: isSelfTransferTabEnabled,
    };
    // console.log("benetype",beneType)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isloading, setIsloading] = useState(false);

    const { t } = useLanguage();

    const primarycolor = getComputedStyle(document.documentElement)
        .getPropertyValue("--primary-color")
        .trim();

    const NEFTSvg = `
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.6932 12.8144H4.32503C4.04354 12.8144 3.77358 12.7026 3.57454 12.5036C3.37549 12.3045 3.26367 12.0346 3.26367 11.7531V5.38491C3.26351 5.17488 3.32567 4.96951 3.44228 4.79482C3.55889 4.62012 3.72471 4.48396 3.91875 4.40356C4.1128 4.32316 4.32633 4.30214 4.53232 4.34316C4.73832 4.38418 4.92751 4.4854 5.07595 4.634L7.50911 7.06982C9.86029 4.80071 12.9978 3.52859 16.2653 3.51957H16.3357C19.6631 3.511 22.86 4.81368 25.2338 7.14545C25.4277 7.34374 25.5362 7.61001 25.5362 7.88729C25.5362 8.16458 25.4277 8.43086 25.2339 8.62917C25.0401 8.82748 24.7764 8.94207 24.4992 8.94843C24.222 8.95479 23.9533 8.85241 23.7506 8.66319C21.7719 6.721 19.1082 5.6358 16.3357 5.64229H16.276C13.5697 5.64995 10.97 6.69781 9.01492 8.569L11.4441 11.0022C11.5927 11.1506 11.6939 11.3398 11.735 11.5458C11.776 11.7518 11.755 11.9653 11.6746 12.1594C11.5942 12.3534 11.458 12.5192 11.2833 12.6358C11.1086 12.7524 10.9032 12.8146 10.6932 12.8144ZM27.675 19.1826H21.3068C21.0968 19.1824 20.8914 19.2446 20.7167 19.3612C20.542 19.4778 20.4058 19.6436 20.3254 19.8377C20.245 20.0317 20.224 20.2453 20.265 20.4513C20.3061 20.6572 20.4073 20.8464 20.5559 20.9949L22.9851 23.428C21.0309 25.3004 18.4317 26.3497 15.7254 26.3587H15.6657C12.8931 26.3652 10.2294 25.28 8.25074 23.3378C8.15188 23.2367 8.03381 23.1563 7.90346 23.1015C7.77311 23.0466 7.63311 23.0184 7.49169 23.0184C7.35027 23.0184 7.21027 23.0466 7.07993 23.1015C6.94958 23.1564 6.83152 23.2368 6.73268 23.3379C6.63383 23.4391 6.5562 23.5589 6.50433 23.6905C6.45247 23.8221 6.42742 23.9627 6.43067 24.1041C6.43391 24.2455 6.46538 24.3848 6.52322 24.5138C6.58106 24.6429 6.66411 24.7591 6.76749 24.8556C9.14131 27.1873 12.3382 28.49 15.6657 28.4814H15.7347C19.0022 28.4724 22.1397 27.2003 24.4909 24.9312L26.9267 27.367C27.0755 27.515 27.2648 27.6155 27.4708 27.6558C27.6767 27.6962 27.8899 27.6746 28.0836 27.5938C28.2772 27.5131 28.4426 27.3767 28.5588 27.2019C28.675 27.0272 28.7368 26.822 28.7363 26.6121V20.244C28.7363 19.9625 28.6245 19.6925 28.4255 19.4935C28.2264 19.2944 27.9565 19.1826 27.675 19.1826Z" fill="${primarycolor}"/>
<circle cx="15.9999" cy="15.9999" r="5.45009" fill="${primarycolor}"/>
<path d="M17.1269 15.1771V15.2746H17.9354V15.8462H17.0851C17.0339 16.1575 16.9364 16.4061 16.7923 16.5919C16.6529 16.7731 16.4531 16.9055 16.1929 16.9892C15.9327 17.0682 15.5959 17.1077 15.1823 17.1077V17.5468C15.1823 17.8023 15.2358 18.0044 15.3426 18.1531C15.4542 18.3018 15.64 18.3762 15.9002 18.3762C16.3742 18.3762 16.6111 18.109 16.6111 17.5746H17.3429C17.3383 18.0439 17.2105 18.3994 16.9596 18.641C16.7133 18.878 16.3556 18.9965 15.8863 18.9965C15.417 18.9965 15.0569 18.8664 14.806 18.6062C14.5597 18.3459 14.4366 17.9812 14.4366 17.5119V16.5571C14.9523 16.5571 15.331 16.5431 15.5726 16.5152C15.8143 16.4827 15.9931 16.4177 16.1093 16.3201C16.2301 16.2225 16.3091 16.0645 16.3463 15.8462H14.1438V15.2746H16.3811V15.1771V14.6543H14.1438V14.0758H17.9354V14.6543H17.1269V15.1771Z" fill="white"/>
</svg>
`;
    const NEFTSvgIcon =
        "data:image/svg+xml," + encodeURIComponent(NEFTSvg);


    const RTGSSvg = `
<svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.1152 20.0324C14.1152 20.1457 14.0702 20.2544 13.9901 20.3345C13.91 20.4146 13.8013 20.4596 13.688 20.4596H1.72698C1.61369 20.4596 1.50503 20.4146 1.42492 20.3345C1.34481 20.2544 1.2998 20.1457 1.2998 20.0324C1.2998 19.9191 1.34481 19.8105 1.42492 19.7304C1.50503 19.6503 1.61369 19.6053 1.72698 19.6053H13.688C13.8013 19.6053 13.91 19.6503 13.9901 19.7304C14.0702 19.8105 14.1152 19.9191 14.1152 20.0324ZM1.743 14.1683C1.7176 14.0787 1.72216 13.9833 1.75599 13.8966C1.78982 13.8098 1.85108 13.7365 1.93043 13.6877L7.48376 10.2703C7.55106 10.2289 7.62851 10.207 7.7075 10.207C7.78649 10.207 7.86394 10.2289 7.93124 10.2703L13.4846 13.6877C13.5639 13.7364 13.6252 13.8097 13.6591 13.8964C13.693 13.9831 13.6977 14.0785 13.6723 14.1681C13.647 14.2577 13.5931 14.3366 13.5188 14.3927C13.4445 14.4489 13.3539 14.4792 13.2608 14.4791H11.9793V17.8965H12.8337C12.947 17.8965 13.0556 17.9415 13.1357 18.0217C13.2158 18.1018 13.2608 18.2104 13.2608 18.3237C13.2608 18.437 13.2158 18.5457 13.1357 18.6258C13.0556 18.7059 12.947 18.7509 12.8337 18.7509H2.58134C2.46805 18.7509 2.35939 18.7059 2.27928 18.6258C2.19917 18.5457 2.15416 18.437 2.15416 18.3237C2.15416 18.2104 2.19917 18.1018 2.27928 18.0217C2.35939 17.9415 2.46805 17.8965 2.58134 17.8965H3.4357V14.4791H2.15416C2.06114 14.4791 1.97065 14.4488 1.89644 14.3927C1.82223 14.3366 1.76835 14.2578 1.743 14.1683ZM8.56186 17.4694C8.56186 17.5826 8.60687 17.6913 8.68698 17.7714C8.76709 17.8515 8.87574 17.8965 8.98904 17.8965C9.10233 17.8965 9.21099 17.8515 9.2911 17.7714C9.37121 17.6913 9.41622 17.5826 9.41622 17.4694V14.9063C9.41622 14.793 9.37121 14.6843 9.2911 14.6042C9.21099 14.5241 9.10233 14.4791 8.98904 14.4791C8.87574 14.4791 8.76709 14.5241 8.68698 14.6042C8.60687 14.6843 8.56186 14.793 8.56186 14.9063V17.4694ZM5.99878 17.4694C5.99878 17.5826 6.04379 17.6913 6.1239 17.7714C6.20401 17.8515 6.31267 17.8965 6.42596 17.8965C6.53926 17.8965 6.64791 17.8515 6.72802 17.7714C6.80813 17.6913 6.85314 17.5826 6.85314 17.4694V14.9063C6.85314 14.793 6.80813 14.6843 6.72802 14.6042C6.64791 14.5241 6.53926 14.4791 6.42596 14.4791C6.31267 14.4791 6.20401 14.5241 6.1239 14.6042C6.04379 14.6843 5.99878 14.793 5.99878 14.9063V17.4694Z" fill="${primarycolor}"/>
<path d="M30.7011 20.0324C30.7011 20.1457 30.6561 20.2544 30.576 20.3345C30.4959 20.4146 30.3872 20.4596 30.274 20.4596H18.3129C18.1996 20.4596 18.091 20.4146 18.0109 20.3345C17.9307 20.2544 17.8857 20.1457 17.8857 20.0324C17.8857 19.9191 17.9307 19.8105 18.0109 19.7304C18.091 19.6503 18.1996 19.6053 18.3129 19.6053H30.274C30.3872 19.6053 30.4959 19.6503 30.576 19.7304C30.6561 19.8105 30.7011 19.9191 30.7011 20.0324ZM18.3289 14.1683C18.3035 14.0787 18.3081 13.9833 18.3419 13.8966C18.3758 13.8098 18.437 13.7365 18.5164 13.6877L24.0697 10.2703C24.137 10.2289 24.2144 10.207 24.2934 10.207C24.3724 10.207 24.4499 10.2289 24.5172 10.2703L30.0705 13.6877C30.1499 13.7364 30.2112 13.8097 30.2451 13.8964C30.279 13.9831 30.2836 14.0785 30.2583 14.1681C30.2329 14.2577 30.179 14.3366 30.1048 14.3927C30.0305 14.4489 29.9399 14.4792 29.8468 14.4791H28.5652V17.8965H29.4196C29.5329 17.8965 29.6415 17.9415 29.7217 18.0217C29.8018 18.1018 29.8468 18.2104 29.8468 18.3237C29.8468 18.437 29.8018 18.5457 29.7217 18.6258C29.6415 18.7059 29.5329 18.7509 29.4196 18.7509H19.1673C19.054 18.7509 18.9453 18.7059 18.8652 18.6258C18.7851 18.5457 18.7401 18.437 18.7401 18.3237C18.7401 18.2104 18.7851 18.1018 18.8652 18.0217C18.9453 17.9415 19.054 17.8965 19.1673 17.8965H20.0216V14.4791H18.7401C18.6471 14.4791 18.5566 14.4488 18.4824 14.3927C18.4082 14.3366 18.3543 14.2578 18.3289 14.1683ZM25.1478 17.4694C25.1478 17.5826 25.1928 17.6913 25.2729 17.7714C25.353 17.8515 25.4617 17.8965 25.575 17.8965C25.6883 17.8965 25.7969 17.8515 25.877 17.7714C25.9572 17.6913 26.0022 17.5826 26.0022 17.4694V14.9063C26.0022 14.793 25.9572 14.6843 25.877 14.6042C25.7969 14.5241 25.6883 14.4791 25.575 14.4791C25.4617 14.4791 25.353 14.5241 25.2729 14.6042C25.1928 14.6843 25.1478 14.793 25.1478 14.9063V17.4694ZM22.5847 17.4694C22.5847 17.5826 22.6297 17.6913 22.7098 17.7714C22.7899 17.8515 22.8986 17.8965 23.0119 17.8965C23.1252 17.8965 23.2338 17.8515 23.314 17.7714C23.3941 17.6913 23.4391 17.5826 23.4391 17.4694V14.9063C23.4391 14.793 23.3941 14.6843 23.314 14.6042C23.2338 14.5241 23.1252 14.4791 23.0119 14.4791C22.8986 14.4791 22.7899 14.5241 22.7098 14.6042C22.6297 14.6843 22.5847 14.793 22.5847 14.9063V17.4694Z" fill="${primarycolor}"/>
<path d="M22.8237 10.2919H18.2855C18.1358 10.292 17.9895 10.2477 17.865 10.1646C17.7405 10.0815 17.6434 9.96335 17.5861 9.82506C17.5288 9.68678 17.5139 9.53461 17.5431 9.38781C17.5723 9.24101 17.6445 9.10618 17.7504 9.0004L19.4815 7.26643C18.0882 5.93294 16.2356 5.1862 14.307 5.18074H14.2644C12.2886 5.17611 10.3903 5.94947 8.98026 7.33355C8.83581 7.4684 8.64433 7.54136 8.44678 7.53682C8.24922 7.53229 8.06129 7.45063 7.92318 7.30931C7.78507 7.16798 7.70774 6.97822 7.70775 6.78061C7.70776 6.58301 7.78511 6.39325 7.92323 6.25195C9.61492 4.59024 11.8932 3.66189 14.2644 3.668H14.3146C16.6431 3.67443 18.8791 4.58099 20.5546 6.19805L22.2886 4.46219C22.3944 4.35629 22.5292 4.28415 22.676 4.25492C22.8228 4.22569 22.975 4.24066 23.1132 4.29796C23.2515 4.35526 23.3697 4.4523 23.4528 4.57679C23.5359 4.70128 23.5802 4.84764 23.5801 4.99732V9.53553C23.5801 9.73614 23.5004 9.92852 23.3585 10.0704C23.2167 10.2122 23.0243 10.2919 22.8237 10.2919Z" fill="${primarycolor}"/>
<path d="M21.302 22.3189C21.2494 22.2861 21.1894 22.2672 21.1276 22.264C21.0658 22.2608 21.0042 22.2734 20.9486 22.3006C18.9909 23.2582 17.5928 22.8095 16.1149 22.3362C14.5604 21.8414 12.9552 21.3284 10.734 22.4128C10.6727 22.4427 10.621 22.4893 10.5848 22.5472C10.5486 22.6051 10.5294 22.6719 10.5293 22.7402V28.2091C10.5293 28.271 10.545 28.3318 10.575 28.386C10.605 28.4401 10.6483 28.4857 10.7008 28.5185C10.7533 28.5513 10.8133 28.5702 10.8751 28.5734C10.9369 28.5767 10.9985 28.5641 11.0542 28.5369C13.0118 27.5793 14.4099 28.028 15.8901 28.5014C16.7674 28.7818 17.6612 29.0677 18.6717 29.0677C19.451 29.0677 20.301 28.8981 21.2668 28.4266C21.3282 28.3966 21.3799 28.3501 21.4161 28.2922C21.4523 28.2343 21.4715 28.1674 21.4716 28.0992V22.6303C21.4721 22.5682 21.4568 22.5071 21.4272 22.4526C21.3975 22.3981 21.3544 22.3521 21.302 22.3189ZM12.3533 26.5141C12.3533 26.6109 12.3149 26.7036 12.2465 26.7721C12.1781 26.8405 12.0853 26.8789 11.9885 26.8789C11.8918 26.8789 11.799 26.8405 11.7306 26.7721C11.6621 26.7036 11.6237 26.6109 11.6237 26.5141V23.5957C11.6237 23.4989 11.6621 23.4061 11.7306 23.3377C11.799 23.2693 11.8918 23.2309 11.9885 23.2309C12.0853 23.2309 12.1781 23.2693 12.2465 23.3377C12.3149 23.4061 12.3533 23.4989 12.3533 23.5957V26.5141ZM16.0014 26.8789C15.7127 26.8789 15.4306 26.7933 15.1907 26.633C14.9507 26.4726 14.7637 26.2447 14.6532 25.9781C14.5428 25.7115 14.5139 25.4181 14.5702 25.135C14.6265 24.8519 14.7655 24.5919 14.9695 24.3879C15.1736 24.1838 15.4336 24.0448 15.7167 23.9885C15.9997 23.9322 16.2931 23.9611 16.5598 24.0715C16.8264 24.182 17.0543 24.369 17.2146 24.609C17.375 24.849 17.4606 25.1311 17.4606 25.4197C17.4606 25.8067 17.3068 26.1779 17.0332 26.4515C16.7595 26.7252 16.3884 26.8789 16.0014 26.8789ZM20.379 27.2437C20.379 27.3405 20.3406 27.4332 20.2722 27.5017C20.2037 27.5701 20.1109 27.6085 20.0142 27.6085C19.9174 27.6085 19.8247 27.5701 19.7562 27.5017C19.6878 27.4332 19.6494 27.3405 19.6494 27.2437V24.3253C19.6494 24.2285 19.6878 24.1357 19.7562 24.0673C19.8247 23.9989 19.9174 23.9605 20.0142 23.9605C20.1109 23.9605 20.2037 23.9989 20.2722 24.0673C20.3406 24.1357 20.379 24.2285 20.379 24.3253V27.2437Z" fill="${primarycolor}"/>
</svg>


`;
    const RTGSSvgIcon =
        "data:image/svg+xml," + encodeURIComponent(RTGSSvg);


    const WithinBankSvg = `
 <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27.0544 24.4395C27.0544 24.6349 26.9768 24.8224 26.8386 24.9606C26.7004 25.0988 26.5129 25.1764 26.3175 25.1764H5.68417C5.48873 25.1764 5.3013 25.0988 5.1631 24.9606C5.0249 24.8224 4.94727 24.6349 4.94727 24.4395C4.94727 24.2441 5.0249 24.0566 5.1631 23.9184C5.3013 23.7802 5.48873 23.7026 5.68417 23.7026H26.3175C26.5129 23.7026 26.7004 23.7802 26.8386 23.9184C26.9768 24.0566 27.0544 24.2441 27.0544 24.4395ZM5.7118 14.3236C5.66797 14.1691 5.67584 14.0045 5.73421 13.8548C5.79257 13.7052 5.89824 13.5787 6.03512 13.4946L15.6149 7.59939C15.731 7.52802 15.8646 7.49023 16.0008 7.49023C16.1371 7.49023 16.2707 7.52802 16.3868 7.59939L25.9666 13.4946C26.1035 13.5786 26.2092 13.705 26.2677 13.8546C26.3262 14.0042 26.3342 14.1688 26.2905 14.3233C26.2468 14.4779 26.1538 14.6139 26.0256 14.7108C25.8975 14.8076 25.7412 14.8599 25.5806 14.8597H23.3699V20.755H24.8437C25.0391 20.755 25.2266 20.8326 25.3648 20.9708C25.503 21.109 25.5806 21.2964 25.5806 21.4919C25.5806 21.6873 25.503 21.8748 25.3648 22.013C25.2266 22.1512 25.0391 22.2288 24.8437 22.2288H7.15798C6.96254 22.2288 6.77511 22.1512 6.63691 22.013C6.49871 21.8748 6.42107 21.6873 6.42107 21.4919C6.42107 21.2964 6.49871 21.109 6.63691 20.9708C6.77511 20.8326 6.96254 20.755 7.15798 20.755H8.63179V14.8597H6.42107C6.2606 14.8598 6.1045 14.8075 5.97648 14.7107C5.84847 14.6139 5.75553 14.478 5.7118 14.3236ZM17.4746 20.0181C17.4746 20.2135 17.5523 20.401 17.6905 20.5391C17.8287 20.6773 18.0161 20.755 18.2115 20.755C18.407 20.755 18.5944 20.6773 18.7326 20.5391C18.8708 20.401 18.9485 20.2135 18.9485 20.0181V15.5966C18.9485 15.4012 18.8708 15.2138 18.7326 15.0756C18.5944 14.9374 18.407 14.8597 18.2115 14.8597C18.0161 14.8597 17.8287 14.9374 17.6905 15.0756C17.5523 15.2138 17.4746 15.4012 17.4746 15.5966V20.0181ZM13.0532 20.0181C13.0532 20.2135 13.1309 20.401 13.2691 20.5391C13.4072 20.6773 13.5947 20.755 13.7901 20.755C13.9856 20.755 14.173 20.6773 14.3112 20.5391C14.4494 20.401 14.527 20.2135 14.527 20.0181V15.5966C14.527 15.4012 14.4494 15.2138 14.3112 15.0756C14.173 14.9374 13.9856 14.8597 13.7901 14.8597C13.5947 14.8597 13.4072 14.9374 13.2691 15.0756C13.1309 15.2138 13.0532 15.4012 13.0532 15.5966V20.0181Z" fill="${primarycolor}"/>
</svg>
`;
    const WithinBankSvgSvgIcon =
        "data:image/svg+xml," + encodeURIComponent(WithinBankSvg);


    const SelfAccountSvg = `
<svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.0665 7.0293H7.0105C6.59927 7.0293 6.20489 7.19266 5.9141 7.48344C5.62332 7.77422 5.45996 8.16861 5.45996 8.57984V21.7595C5.45996 22.1707 5.62332 22.5651 5.9141 22.8559C6.20489 23.1466 6.59927 23.31 7.0105 23.31H8.56105V24.8605C8.56105 25.0662 8.64273 25.2634 8.78812 25.4087C8.93351 25.5541 9.1307 25.6358 9.33632 25.6358C9.54193 25.6358 9.73913 25.5541 9.88452 25.4087C10.0299 25.2634 10.1116 25.0662 10.1116 24.8605V23.31H20.9654V24.8605C20.9654 25.0662 21.0471 25.2634 21.1925 25.4087C21.3379 25.5541 21.5351 25.6358 21.7407 25.6358C21.9463 25.6358 22.1435 25.5541 22.2889 25.4087C22.4343 25.2634 22.5159 25.0662 22.5159 24.8605V23.31H24.0665C24.4777 23.31 24.8721 23.1466 25.1629 22.8559C25.4537 22.5651 25.617 22.1707 25.617 21.7595V8.57984C25.617 8.16861 25.4537 7.77422 25.1629 7.48344C24.8721 7.19266 24.4777 7.0293 24.0665 7.0293ZM23.2912 16.3326H20.4896C20.299 17.1688 19.807 17.9056 19.1076 18.4021C18.4081 18.8986 17.5503 19.12 16.698 19.0241C15.8457 18.9282 15.0585 18.5217 14.4869 17.8822C13.9153 17.2427 13.5994 16.415 13.5994 15.5573C13.5994 14.6996 13.9153 13.8719 14.4869 13.2324C15.0585 12.5929 15.8457 12.1863 16.698 12.0904C17.5503 11.9945 18.4081 12.216 19.1076 12.7125C19.807 13.209 20.299 13.9457 20.4896 14.782H23.2912C23.4968 14.782 23.694 14.8637 23.8394 15.0091C23.9848 15.1545 24.0665 15.3517 24.0665 15.5573C24.0665 15.7629 23.9848 15.9601 23.8394 16.1055C23.694 16.2509 23.4968 16.3326 23.2912 16.3326ZM19.0272 15.5573C19.0272 15.9406 18.9135 16.3153 18.7006 16.6341C18.4876 16.9528 18.1849 17.2012 17.8307 17.3479C17.4766 17.4946 17.0869 17.533 16.7109 17.4582C16.3349 17.3834 15.9896 17.1988 15.7185 16.9278C15.4475 16.6567 15.2629 16.3114 15.1881 15.9354C15.1133 15.5594 15.1517 15.1697 15.2984 14.8156C15.4451 14.4614 15.6935 14.1587 16.0122 13.9457C16.331 13.7328 16.7057 13.6191 17.089 13.6191C17.3436 13.6191 17.5956 13.6692 17.8307 13.7666C18.0659 13.864 18.2796 14.0068 18.4595 14.1868C18.6395 14.3668 18.7823 14.5804 18.8797 14.8156C18.9771 15.0507 19.0272 15.3028 19.0272 15.5573Z" fill="${primarycolor}"/>
</svg>



`;


    const SelfAccountSvgIcon =
        "data:image/svg+xml," + encodeURIComponent(SelfAccountSvg);


    const [chosen, setChosen] = useState(null);

    const Funds_Transfer = [
        {
            id: "neft",
            label: "NEFT",
            icon: NEFTSvgIcon,
            route: "/fundtransfer/neft",
        },
        {
            id: "rtgs",
            label: "RTGS",
            icon: RTGSSvgIcon,
            route: "/fundtransfer/rtgs",
        },
        {
            id: "withinbank",
            label: "With In Bank",
            icon: WithinBankSvgSvgIcon,
            route: "/fundtransfer/internal",
        },
        {
            id: "selfaccount",
            label: "Self Account",
            icon: SelfAccountSvgIcon,
            route: "/generateqr",
        },
    ];

    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title">
            <Box sx={style} className={classes.box1} component="form">
                <div className={classes.quicklinks}>
                    <div className={classes.modalql}>
                        <div>

                        </div>
                        <div>
                            <div className={classes.qlHeading}>
                                Funds Transfer
                            </div>
                            <div className={classes.qlSubHeading}>
                                Select Fund transfer type
                            </div>
                        </div>

                        <div className={classes.cancelButton}>
                            <IconButton aria-label="delete" onClick={handleClose}>
                                <HighlightOffIcon />
                            </IconButton>
                        </div>
                    </div>

                    {/* <div className={classes.mainQuickLinks}>
                        {Funds_Transfer.map((link) => (
                            <button
                                key={link.id}
                                type="button"
                                onClick={() => setChosen(link.id)}
                                className={`${classes.quickLinksbox} ${chosen === link.id ? classes.selected : ""
                                    }`}
                            >
                                <div className={classes.accountBoxImage}>
                                    <img
                                        className={classes.iconImagesPaddingType1}
                                        src={link.icon}
                                        alt={link.label}
                                    />
                                </div>
                                <div className={classes.accDetailsHeading}>{link.label}</div>
                            </button>
                        ))}
                    </div> */}
                    {/* <div className={classes.mainQuickLinks}>
                        {Funds_Transfer
                            .filter((link) => transferEnabled[link.id])
                            .map((link) => (
                                <button
                                    key={link.id}
                                    type="button"
                                    onClick={() => setChosen(link.id)}
                                    className={`${classes.quickLinksbox} ${chosen === link.id ? classes.selected : ""
                                        }`}
                                >
                                    <div className={classes.accountBoxImage}>
                                        <img
                                            className={classes.iconImagesPaddingType1}
                                            src={link.icon}
                                            alt={link.label}
                                        />
                                    </div>
                                    <div className={classes.accDetailsHeading}>{link.label}</div>
                                </button>
                            ))}
                    </div> */}


                    <div className={classes.mainQuickLinks}>
                        {Funds_Transfer
                            .filter((link) => {
                                // first check if feature is enabled
                                if (!transferEnabled[link.id]) return false;

                                // then check based on beneType
                                if (beneType === "E") {
                                    // External → allow only NEFT, RTGS
                                    return link.id === "neft" || link.id === "rtgs";
                                } else if (beneType === "I") {
                                    // Internal → allow only Within Bank
                                    return link.id === "withinbank";
                                }

                                return false; // default: hide
                            })
                            .map((link) => (
                                <button
                                    key={link.id}
                                    type="button"
                                    onClick={() => setChosen(link.id)}
                                    className={`${classes.quickLinksbox} ${chosen === link.id ? classes.selected : ""
                                        }`}
                                >
                                    <div className={classes.accountBoxImage}>
                                        <img
                                            className={classes.iconImagesPaddingType1}
                                            src={link.icon}
                                            alt={link.label}
                                        />
                                    </div>
                                    <div className={classes.accDetailsHeading}>{link.label}</div>
                                </button>
                            ))}
                    </div>


                    <div className={classes.buttonDownloadStatement}>
                        <ColorButton1
                            disabled={!chosen}                           // no change here
                            onClick={() => {
                                const target = Funds_Transfer.find((l) => l.id === chosen);
                                if (target) {
                                    handleClose();
                                    navigate(target.route);
                                }
                            }}
                        >
                            Proceed
                        </ColorButton1>
                    </div>


                </div>




            </Box>
        </Modal>

    );
}
